import BadgeTheme from './BadgeTheme';

export default BadgeTheme;
